interface ValidateUploadFilesParams {
  files: File[];
  limit: number;
  maxSize: number;
}

type UploadFileValidation = { file: File; error?: never } | { file?: never; error: Error };

export function validateUploadFiles({ files, limit, maxSize }: ValidateUploadFilesParams): UploadFileValidation {
  if (files.length === 0) {
    return { error: new Error("No files selected for upload. Please select a file and try again.") };
  }

  if (limit && files.length > limit) {
    return {
      error: new Error(`You can only upload ${limit} file${limit === 1 ? "" : "s"} at a time. Please select fewer files.`),
    };
  }

  const file = files[0];
  if (!file) {
    return { error: new Error("The selected file could not be read. Please try selecting the file again.") };
  }

  if (file.size > maxSize) {
    return {
      error: new Error(
        `The file "${file.name}" (${(file.size / 1024 / 1024).toFixed(1)}MB) exceeds the maximum allowed size of ${maxSize / 1024 / 1024}MB. Please reduce the file size and try again.`,
      ),
    };
  }

  return { file };
}
